$(document).ready(function () {
  $('.ugc-slider').slick({
    slidesToShow: 3, // Number of visible items
    slidesToScroll: 1, // Scroll one item at a time
    dots: true, // Show navigation dots
    arrows: true, // Show previous/next arrows
    infinite: true, // Infinite scrolling
    responsive: [
      {
        breakpoint: 768, // For tablets and smaller devices
        settings: {
          slidesToShow: 1, // Show one item
        },
      },
    ],
  });
});
